import localize from '../../common/localize';

export default function NoDataLabel({ text }) {
  return <p className="no_data_label">{text ?? localize.no_data}</p>;
}
